import akademiaSportuLogo from '@/assets/clubs/akademia-sportu.png';

/**
 * Mapowanie adresu ekranu prezentacji na klub i jego oprawe.
 *
 * Skroty sa na razie zaszyte w kodzie — link dostaje klub bezposrednio, wiec
 * nie ma potrzeby nawigowac do niego z aplikacji ani rozwiazywac skrotow po
 * stronie backendu. Gdy ekranow przybedzie, to miejsce zastapi pole `slug`
 * na kluby w `club-service` i publiczny endpoint slug -> klub.
 */

/** Oprawa jednego ekranu prezentacji. */
export interface PublicScreenConfig {
  /** Klub organizatora — zrodlo listy rozgrywek. */
  clubId: string;
  /** Tytul na pasku gornym — organizator i nazwa imprezy w jednej linii. */
  title: string;
  /**
   * Obiekt, na ktorym toczy sie impreza. Trzymamy go tutaj, bo rozgrywki
   * w bazie w wiekszosci nie maja ustawionego `venueClubId` i backend
   * podstawia wtedy klub organizatora — a to nie jest miejsce gry.
   */
  venue: string;
  /**
   * Logo organizatora zaszyte w buildzie (import z `@/assets`). Ma
   * pierwszenstwo przed `clubLogoUrl` z publicznego API — adresy MinIO
   * bywaja nieosiagalne z przegladarki, a ekran ma dzialac zawsze.
   */
  logo?: string;
}

export const PUBLIC_SCREEN_CLUBS = {
  /** Akademia Sportu (Warszawa) grajaca w Fabryce Sportow w Kozlowie. */
  'akademia-sportu': {
    clubId: '7c9e6679-7425-40de-944b-e07fc1f90ae7',
    title: 'Tennis Cup Kozłów 2026',
    venue: 'Fabryka Sportów, ul. Marcina 35, 44-153 Kozłów',
    logo: akademiaSportuLogo,
  },
} as const satisfies Record<string, PublicScreenConfig>;

/** Skrot klubu w adresie `/<skrot>`. */
export type PublicScreenSlug = keyof typeof PUBLIC_SCREEN_CLUBS;

/** Zwraca oprawe ekranu dla skrotu albo `null`, gdy skrot jest nieznany. */
export function publicScreenConfig(slug: string | undefined): PublicScreenConfig | null {
  if (!slug) return null;
  return PUBLIC_SCREEN_CLUBS[slug as PublicScreenSlug] ?? null;
}

/** Zwraca identyfikator klubu dla skrotu albo `null`, gdy skrot jest nieznany. */
export function publicScreenClubId(slug: string | undefined): string | null {
  return publicScreenConfig(slug)?.clubId ?? null;
}
